@if (isOpen) {
  @if (usesNativeDialog) {
    <dialog #nativeDialog data-sm-modal class="sm-confirmation-dialog sm-confirmation-dialog--review"
      [style.padding-top.px]="anchorInsets?.top" [style.padding-right.px]="anchorInsets?.right"
      [style.padding-bottom.px]="anchorInsets?.bottom" [style.padding-left.px]="anchorInsets?.left"
      [class.sm-confirmation-dialog--form]="panelVariant === 'form'"
      [class.sm-confirmation-dialog--mobile-fullscreen]="fullScreenOnMobile"
      [attr.aria-labelledby]="titleId" (cancel)="handleNativeCancel($event)">
      <ng-container [ngTemplateOutlet]="dialogContent" />
    </dialog>
  } @else {
    <div #nonNativeDialog class="sm-confirmation-dialog"><ng-container [ngTemplateOutlet]="dialogContent" /></div>
  }
}
<ng-template #dialogContent>
    <button
      type="button"
      class="sm-confirmation-dialog__backdrop"
      [attr.tabindex]="usesNativeDialog ? -1 : null"
      [attr.aria-hidden]="usesNativeDialog ? 'true' : null"
      [attr.aria-label]="closeLabel"
      (click)="handleBackdropClick()">
    </button>

    <section
      class="sm-confirmation-dialog__panel"
      [class.sm-confirmation-dialog__panel--center]="contentAlign === 'center'"
      [class.sm-confirmation-dialog__panel--wide]="panelVariant === 'wide'"
      [class.sm-confirmation-dialog__panel--notice]="panelVariant === 'notice'"
      [class.sm-confirmation-dialog__panel--review]="usesNativeDialog"
      [style.width]="panelWidth ?? (panelVariant === 'wide' ? 'min(100%, 34rem)' : null)"
      [style.max-height]="expandToViewport || panelVariant === 'wide' ? 'calc(100dvh - 2rem)' : null"
      [attr.role]="usesNativeDialog ? null : 'dialog'"
      [attr.aria-modal]="usesNativeDialog ? null : 'true'"
      [attr.aria-labelledby]="titleId">
      <header class="sm-confirmation-dialog__header">
        <div
          class="sm-dialog-heading"
          [class.sm-dialog-centered-heading]="contentAlign === 'center'"
          [class.sm-dialog-inline-hero]="contentAlign === 'start' && hasHeroIcon">
          @if (hasHeroIcon) {
            <div
              class="sm-dialog-hero"
              [class.is-information]="dialogType === 'information'"
              [class.is-warning]="dialogType === 'warning' || heroIconName === 'warning-outline' || heroIconName === 'warning'"
              [class.is-danger]="dialogType === 'danger' || (dialogType === 'default' && confirmTone === 'danger')">
              <ion-icon [name]="heroIconName" aria-hidden="true"></ion-icon>
            </div>
          }

          <h2 tabindex="-1" [id]="titleId" class="sm-confirmation-dialog__title">{{ title }}</h2>
          @if (description) {
            <p class="sm-confirmation-dialog__description">{{ description }}</p>
          }
        </div>

      </header>

      <div class="sm-confirmation-dialog__body" [class.sm-confirmation-dialog__body--center]="contentAlign === 'center'">
        <div
          class="sm-confirmation-dialog__content"
          [class.sm-confirmation-dialog__content--center]="contentAlign === 'center'">
          <ng-content></ng-content>
        </div>

        @if (requiresTypedConfirmation) {
          <p class="sm-confirmation-dialog__prompt">
            {{ confirmationPrompt }}
            <code class="sm-confirmation-dialog__code">{{ confirmationText }}</code>
          </p>

          <sm-input
            [label]="''"
            [placeholder]="confirmationPlaceholder"
            [autocomplete]="'off'"
            [autocapitalize]="'off'"
            [invalid]="showMismatchError"
            [errorText]="showMismatchError ? confirmationMismatchLabel : ''"
            [formControl]="confirmationControl">
          </sm-input>
        }

        @if (hasTextInput) {
          @if (textInputMultiline) {
            <sm-textarea
              [label]="textInputLabel"
              [ariaLabel]="textInputLabel || textInputPlaceholder"
              [placeholder]="textInputPlaceholder"
              [formControl]="textInputControl">
            </sm-textarea>
          } @else {
            <sm-input
              [label]="textInputLabel"
              [ariaLabel]="textInputLabel || textInputPlaceholder"
              [placeholder]="textInputPlaceholder"
              [autocomplete]="'off'"
              [inputmode]="textInputInputMode"
              [formControl]="textInputControl">
            </sm-input>
          }
        }

        @if (error) {
          <p class="sm-confirmation-dialog__error">{{ error }}</p>
        }
      </div>

      <footer class="sm-confirmation-dialog__actions"
        [class.sm-confirmation-dialog__actions--three]="showAlternateButton"
        [class.is-compact]="compactActions"
        [class.sm-confirmation-dialog__actions--center]="actionsAlign === 'center'">
        @if (showCancelButton) {
          <sm-action-button
            type="button"
            size="sm"
            variant="secondary"
            [disabled]="busy"
            (click)="handleCancel()">
            {{ cancelLabel }}
          </sm-action-button>
        }

        @if (showAlternateButton) {
          <sm-action-button
            type="button"
            size="sm"
            variant="secondary"
            [disabled]="busy"
            (click)="handleAlternate()">
            {{ alternateLabel }}
          </sm-action-button>
        }

        @if (showConfirmButton) {
          <sm-action-button
            type="button"
            size="sm"
            [variant]="confirmTone"
            [busy]="busy"
            [disabled]="!canConfirm"
            (click)="handleConfirm()">
            {{ confirmLabel }}
          </sm-action-button>
        }
      </footer>
    </section>
</ng-template>
